function CreateIcon() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5ZM10.5 4.875C11.1213 4.875 11.625 5.37868 11.625 6V9.375H15C15.6213 9.375 16.125 9.87868 16.125 10.5C16.125 11.1213 15.6213 11.625 15 11.625H11.625V15C11.625 15.6213 11.1213 16.125 10.5 16.125C9.87868 16.125 9.375 15.6213 9.375 15V11.625H6C5.37868 11.625 4.875 11.1213 4.875 10.5C4.875 9.87868 5.37868 9.375 6 9.375H9.375V6C9.375 5.37868 9.87868 4.875 10.5 4.875Z"
        fill="black"
      />
    </svg>
  );
}

export default CreateIcon;
